import { render, staticRenderFns } from "./LoginFormComp.vue?vue&type=template&id=cb7f7d50&scoped=true&"
import script from "./LoginFormComp.vue?vue&type=script&lang=ts&"
export * from "./LoginFormComp.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFormComp.vue?vue&type=style&index=0&id=cb7f7d50&lang=scss&scoped=true&"
import style1 from "./LoginFormComp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f7d50",
  null
  
)

export default component.exports